// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"
import { urlQueryBuilder } from "~utils/utils"

// Shapes
import { TableOptionsShape } from "~shapes/api-table"
import { PerkRedemptionTypePayload, PostPerkShape } from "~shapes/perk"
import { PERK_REDEMPTION_STATUS } from "~constants/status"
import { filtersProps } from "~components/dashboard/RedemptionWidget"

const PerkService = {
  getPerk: async (id: string) => {
    const perksUrl = `${Endpoints.PERKS.URL}/${id}?projection=includeCompany`
    const response = await Api.get(perksUrl)
    return response.data
  },
  getPerks: async (options?: TableOptionsShape) => {
    let perksUrl = `${Endpoints.PERKS.URL}?projection=includeCompany&sort=createdAt,desc`
    if (options) {
      const query = urlQueryBuilder(options)
      perksUrl = `${perksUrl}&${query}`
    }
    const response = await Api.get(perksUrl)
    return { pages: response.data.page, result: response.data._embedded.perks }
  },
  postPerk: async (perk: PostPerkShape) => {
    const response = await Api.post(Endpoints.PERKS.URL, perk)
    return response.data
  },
  patchPerk: async (perk: Partial<PostPerkShape>) => {
    const { id, ...rest } = perk

    const perkUrl = `${Endpoints.PERKS.URL}/${id}`
    const response = await Api.patch(perkUrl, rest)
    return response.data
  },
  getPerkRedemptionType: async (id: string) => {
    const url = `${Endpoints.PERKS.URL}/${id}/redemptionTypes`
    const response = await Api.get(url)
    return response.data
  },
  postPerkRedemptionType: async (payload: PerkRedemptionTypePayload) => {
    const url = `${Endpoints.REDEMPTION_TYPES.URL}`
    const response = await Api.post(url, payload)
    return response.data
  },
  getPerkRedemptionTypeCoupons: async (id: string) => {
    const url = `${Endpoints.REDEMPTION_TYPES.URL}/${id}/coupons`
    const response = await Api.get(url)
    return response.data
  },
  getPerkRedemptions: async (filters: filtersProps, { pageParam }) => {
    let url = `${Endpoints.PERK_REDEMPTIONS.URL}?size=100&page=${pageParam}`
    if (filters) {
      const safeFilters = { ...filters }

      if (!safeFilters.sort) {
        safeFilters.sort = "createdAt,desc"
      }

      if (safeFilters.userEmail) {
        safeFilters.userEmail = encodeURIComponent(safeFilters.userEmail)
      }
      if (safeFilters.updatedByEmail) {
        safeFilters.updatedByEmail = encodeURIComponent(
          safeFilters.updatedByEmail
        )
      }
      const query = urlQueryBuilder(safeFilters)
      url = `${url}&${query}`
    }

    try {
      const response = await Api.get(url)
      return {
        result: response.data.data,
        hasNextPage: response.data.hasNext ? pageParam + 1 : false,
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default PerkService
